// extracted by mini-css-extract-plugin
export default {"icon":"navMobile_icon__7eReE","flex":"navMobile_flex__zj+i6"};